// extracted by mini-css-extract-plugin
export default {"box":"navigationPanel_box__+R752","space":"navigationPanel_space__J4vL3"};